import Vue from 'vue';
import { gsap } from 'gsap';
import imagesLoaded from 'imagesloaded';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('services-overview-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            revealCompleted: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        imagesLoaded(this.$el, () => {
            Vue.nextTick(() => {
                this.initIntroReveal();

                gsap.delayedCall(0.1, () => {
                    this.initScrollReveals();
                });
            });
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initIntroReveal() {
            this.introTl = gsap.timeline({ delay: 0.2 });

            this.introTl.to('.services__intro-holder ', {
                duration: 4, y: 0, ease: 'power4.out',
            }, 0.2);
            this.introTl.to('.services__intro', {
                duration: 2, y: 0, ease: 'power4.inOut',
            }, 0);
        },

        initScrollReveals() {
            ScrollTrigger.batch('.services__overview-item', {
                start: 'top 100%',
                onEnter: (elements) => {
                    for (let index = 0; index < elements.length; index++) {
                        const element = elements[index];

                        let staggerValue = 0.2;

                        if (element.dataset.index % 2 === 0) {
                            staggerValue = -0.2;
                        }

                        let initialDelay = 0;

                        if (window.scrollY < 20) {
                            initialDelay = 0.8;
                        }

                        gsap.to(element.querySelectorAll('.services__overview-item-image-overlay'), {
                            duration: 2,
                            delay: 0 + initialDelay,
                            y: '-100%',
                            stagger: staggerValue,
                            ease: 'power2.inOut',
                            onComplete: () => {
                                element.classList.add('--revealed');
                            },
                        });
                        gsap.to(element.querySelectorAll('.services__overview-item-image'), {
                            duration: 2, delay: 0 + initialDelay, scale: 1, stagger: staggerValue, ease: 'power2.out',
                        });
                        gsap.to(element.querySelector('.services__overview-item-title'), {
                            duration: 1, delay: 1.8 + initialDelay, y: '0%', stagger: staggerValue, ease: 'power4.out',
                        });
                    }
                },
            });
        },

        enterHover(e) {
            const currentItem = e.currentTarget.parentNode;

            if (!currentItem.classList.contains('--revealed')) {
                return;
            }

            gsap.to(currentItem.querySelector('.services__overview-item-title-hover'), { duration: 0.6, y: '0', ease: 'power4.inOut' });
            gsap.to(currentItem.querySelector('.services__overview-item-title'), { duration: 0.6, y: '100%', ease: 'power4.inOut' });
            gsap.to(this.$el.querySelectorAll(`.services__overview-item:not([data-index="${currentItem.dataset.index}"])`), {
                duration: 0.6, autoAlpha: 0.4, ease: 'power4.inOut',
            });
        },

        leaveHover(e) {
            const currentItem = e.currentTarget.parentNode;

            if (!currentItem.classList.contains('--revealed')) {
                return;
            }

            gsap.to(currentItem.querySelector('.services__overview-item-title-hover'), { duration: 0.6, y: '100%', ease: 'power4.inOut' });
            gsap.to(currentItem.querySelector('.services__overview-item-title'), { duration: 0.6, y: '0%', ease: 'power4.inOut' });
            gsap.to(this.$el.querySelectorAll('.services__overview-item'), { duration: 0.6, autoAlpha: 1, ease: 'power4.inOut' });
        },
    },
});
